import { useQuery } from 'react-query';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import useConvertTimeRange from '@ubeya/shared/hooks/useConvertTimeRange';
import * as api from '@ubeya/shared/services/api';
import { useMemo } from 'react';

const useClientInvoice = ({ clientId, timeRange, enabled }) => {
  const { accountId } = useAccount();
  const timeRangeValue = useConvertTimeRange(timeRange);
  const storeKey = ['client', 'invoices', accountId, clientId, timeRangeValue];

  const { isLoading, data: { data: payroll = [] } = {} } = useQuery(
    storeKey,
    () => api.fetchClientInvoices({ accountId, ...timeRangeValue, clientId }),
    {
      enabled,
      staleTime: 0
    }
  );

  const payrollTotal = useMemo(
    () => payroll.reduce((acc, { totalWithAdditional = 0 }) => acc + totalWithAdditional, 0),
    [payroll]
  );

  return { payroll, payrollTotal, isLoading };
};

export default useClientInvoice;
